/* KLIK catalogue: collection and search lists (package bugs-search, v2, 2026-10-21).
   sections/klik-catalogue.liquid and sections/main-search.liquid render server pages of 24 cards; this script:
   - shows more on "Show more" only, fetching the next server page then (no background download of the catalogue, K-117);
   - loads the whole list once, when a filter, the in-list search or a sort needs it (K-025);
   - keeps the server order while nothing is filtered, so cards never reorder as pages arrive (K-028);
   - remembers the shown count and the clicked card in history.state and restores both on Back (K-028);
   - one count everywhere: the eyebrow, the status line, the sheet button and, on search, the tab title (K-006, K-204);
     a free-text search with more than one page shows "Matching designs" until the exact count (one per twin pair, from
     sections/main-search.liquid rendered as its count view after load) is known, so no number ever changes in view;
   - the filter sheet (bottom sheet on phones, side panel on desktop) with "Show N designs" and Search & Discovery facets;
   - one card per twin pair (the made-to-order card stands for its ready twin unless "Ready" is chosen, K-008);
   - the saved designs (localStorage klikSavedProductsV1, shared with the header "Saved", K-108);
   - phone: on lists with a chip row the name search opens in the sheet (the filter button sits in the chip row);
   - mixed lists (majlis sofas): the two buying-mode chips filter the list (BS-7);
   - the no-results helpers of the search page (closest matches through KlikSearch.alias, WhatsApp context).
   Wave 1 ux (2026-10-27):
   - honest facets (UX-11): "Width as pictured" with "Made to order: choose your size in 3D"; Seats from what can really
     be ordered (a ready set's 11-Seater variant, the card's data-kc-seat-options), or one line when every design offers
     the same; Bed size (data-kc-beds, from the variant titles); Table shape (data-kc-table);
   - a list opened from search with colour=, seats= or width= in its address prints the attribute layer's honest line
     (KlikSearch.note, assets/klik-search-attrs.js), and the search page offers the understood list as one card (UX-03);
   - the second photo of a card (UX-12): on hover with a mouse, on a sideways swipe or the "1/2" pill on phones; fetched
     only on intent (UXR-07): the first sideways move on the photo (10 px, before the 34 px swipe) or a press on the pill.
     After the shopper's first swipe, at most 2 more photos of cards in view for a second are warmed while idle; never on
     Save-Data, 2G or 3G. No layout shift: the photo fades in over the cut-out inside the same frame.
   Review fixes (2026-10-27):
   - every card's photo frame is a layer above the title's stretched link (z-index 2), so the press scale of
     klik-v3-final-collection.css (.kc4-card:active .kc4-card-image) can no longer trap the heart under the link (UXR-08);
   - the Seats hint never says ready-to-ship corner sofas are made to length, and is left out where dining sets supply the
     chips (UXR-02); no 11-seat line for made-to-order sets (UXR-01); dining lists say "chairs" from the first paint;
   - a list whose address filters leave nothing says why and offers the way out (the lowest prices, the bed sizes or the
     chair counts it has), and a relaxed list opened from search prints the search's line (UXR-04).
   Analytics: klik_search_submitted, klik_catalog_filtered (Shopify.analytics.publish). */
(() => {
  'use strict';
  const SAVED_KEY = 'klikSavedProductsV1';
  const PER = 24;
  const AR = /^ar/i.test(document.documentElement.lang || '') || /^ar\./.test(location.hostname);
  const t = (en, ar) => (AR ? ar : en);
  const fold = (value) => (window.KlikSearch && KlikSearch.normalise ? KlikSearch.normalise(value)
    : String(value || '').toLowerCase().normalize('NFKD').replace(/[̀-ًͯ-ٟ]/g, '')
      .replace(/[أإآ]/g, 'ا').replace(/ى/g, 'ي').replace(/ة/g, 'ه').trim());
  /* the count phrase: KlikAr.count (a11y-rtl, the twin of snippets/klik-ar-count.liquid) with the same rules as fallback */
  const designs = (n) => {
    if (window.KlikAr && typeof KlikAr.count === 'function') return KlikAr.count(n, 'design', { lang: AR ? 'ar' : 'en' });
    if (!AR) return n === 1 ? '1 design' : `${n} designs`;
    if (n === 0) return 'لا توجد تصاميم';
    if (n === 1) return 'تصميم واحد';
    if (n === 2) return 'تصميمان';
    const m = n % 100;
    if (m >= 3 && m <= 10) return `${n} تصاميم`;
    if (m >= 11) return `${n} تصميمًا`;
    return `${n} تصميم`;
  };
  const publish = (name, payload) => {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, payload); } catch (e) { /* optional */ }
  };
  const siteName = () => {
    const parts = document.title.split(' | ');
    return parts.length > 1 ? parts[parts.length - 1] : (AR ? 'كليك للأثاث' : 'KLIK Decor');
  };
  const setText = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
  const readSaved = () => {
    try {
      const list = JSON.parse(localStorage.getItem(SAVED_KEY) || '[]');
      return Array.isArray(list) ? list.filter((item) => item && typeof item === 'object' && item.id) : [];
    } catch (e) { return []; }
  };
  const navType = (() => {
    try { return (performance.getEntriesByType('navigation')[0] || {}).type || ''; } catch (e) { return ''; }
  })();

  /* Strip the recommendation tracking tokens from the address (K-028). */
  (() => {
    const url = new URL(location.href);
    let changed = false;
    [...url.searchParams.keys()].forEach((key) => { if (/^_su_rec/.test(key)) { url.searchParams.delete(key); changed = true; } });
    if (changed) history.replaceState(history.state, '', url);
  })();

  /* Sheet open cost (v3 conversion fix). The product page's sticky-bar rule in klik-v3-final.css
     (body:not(:has(.kz-on, dialog[open], [aria-modal=true]:not([hidden]))) > aside.kpdp-bar[hidden]) makes Chrome
     restyle the whole page whenever any dialog opens or closes: 0.8-2.6 s at CPU x4 for the filter and search sheets on
     a collection, 7-111 ms without it (qa/v3-fix-bugs-search/exp3.mjs, 2026-10-22). It only matters where the bar
     exists, so on list and search pages without one it is taken out once the page has loaded; the product page keeps
     it (the core sheet owner has the lasting fix). */
  const dropDialogHasRule = () => {
    if (document.querySelector('aside.kpdp-bar')) return;
    const walk = (list, owner) => {
      for (let i = list.length - 1; i >= 0; i--) {
        const rule = list[i];
        if (rule.selectorText) {
          if (rule.selectorText.indexOf('kpdp-bar') > -1 && rule.selectorText.indexOf(':has(') > -1 && /dialog\[open\]/.test(rule.selectorText)) owner.deleteRule(i);
        } else if (rule.cssRules && typeof rule.deleteRule === 'function') walk(rule.cssRules, rule);
      }
    };
    [...document.styleSheets].forEach((sheet) => {
      if (!/klik-v3-final/.test(sheet.href || '')) return;
      try { walk(sheet.cssRules, sheet); } catch (e) { /* not readable */ }
    });
  };
  if (document.querySelector('[data-catalogue], [data-kc-search-page]')) {
    const later = () => (window.requestIdleCallback || ((fn) => setTimeout(fn, 300)))(dropDialogHasRule);
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
  }

  /* ---------- wave 1 ux: styles for the second photo, the facet hints and the notes (injected once) ---------- */
  const UX_CSS = '.kc4-card--alt{touch-action:pan-y pinch-zoom}'
    + '.kc4-card .kc4-card-image{z-index:2}'
    + '.kc4-card-image .kc4-card-alt{position:absolute;inset:0;background:#fff center/cover no-repeat;opacity:0;transition:opacity .3s ease;pointer-events:none}'
    + '.kc4-card-image.is-alt .kc4-card-alt{opacity:1}'
    + '.kc4-card-image .kc4-card-count{position:absolute;bottom:8px;inset-inline-start:8px;display:inline-flex;align-items:center;min-height:22px;padding:0 8px;border-radius:999px;z-index:3;background:rgba(255,255,255,.94);color:#2e4654;font:600 11.5px/1 Muli,Mulish,system-ui,sans-serif;letter-spacing:.02em;box-shadow:0 1px 2px rgba(46,70,84,.14);cursor:pointer;-webkit-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}'
    + '.kc4-card-image .kc4-card-count::before{content:"";position:absolute;inset:-11px -10px}'
    + '@media (hover:hover) and (pointer:fine){.kc4-card-image .kc4-card-count{display:none}}'
    + '@media (prefers-reduced-motion:reduce){.kc4-card-image .kc4-card-alt{transition:none}}'
    + '.kc4-kfacet .kc4-kfacet-hint{margin:0 0 10px;font-size:13px;line-height:1.5;color:var(--v3-muted,#56626a)}'
    + 'html[lang=ar] .kc4-kfacet .kc4-kfacet-hint{font-size:13.5px;line-height:1.7}'
    + '.kc4-wrap>.kc4-attr-note{order:40}'
    + '.kc4-attr-note{margin:12px 0;padding:10px 14px;border-radius:12px;background:var(--v3-tint,#eef2f5);color:var(--v3-ink,#2e4654);font-size:14px;line-height:1.5}'
    + 'html[lang=ar] .kc4-attr-note{font-size:14.5px;line-height:1.75}'
    + '.kc4-empty .kc4-empty-why[hidden]{display:none!important}'
    + '.kc4-empty .kc4-empty-alt{display:flex;width:fit-content;align-items:center;justify-content:center;min-height:48px;margin:14px 0 0;padding:0 22px;border-radius:8px;background:var(--v3-navy,#2e4654);color:#fff;font-weight:700;font-size:15px;line-height:1.2;text-decoration:none;box-shadow:var(--v3-sh-btn,0 14px 26px -16px rgba(36,58,70,.6))}'
    + '.kc4-empty .kc4-empty-alt:hover{background:var(--v3-navy-deep,#243a46);color:#fff}'
    + '.kc4-empty .kc4-empty-alt:focus-visible{outline:2px solid var(--v3-focus,#2e4654);outline-offset:3px}';
  const addUxStyles = () => {
    if (document.getElementById('KcUxStyle')) return;
    const style = document.createElement('style');
    style.id = 'KcUxStyle';
    style.textContent = UX_CSS;
    document.head.appendChild(style);
  };

  /* ---------- UX-12: the second photo ---------- */
  const fineHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const lowData = (() => { try { const c = navigator.connection; return Boolean(c && (c.saveData || /^(slow-2g|2g|3g)$/.test(c.effectiveType || ''))); } catch (e) { return false; } })();
  /* UXR-07: nothing is fetched before intent; after the first swipe at most WARM_CAP photos are warmed */
  const WARM_CAP = 2;
  let swipedOnce = false;
  let warmed = 0;
  const altBoxes = new Set();
  const altUrl = (box) => {
    try {
      const u = new URL(box.dataset.kcAlt, location.href);
      const css = box.clientWidth || 200;
      u.searchParams.set('width', String(Math.min(900, Math.max(300, Math.ceil((css * Math.min(2, window.devicePixelRatio || 1)) / 100) * 100))));
      return u.href;
    } catch (e) { return ''; }
  };
  const loadAlt = (box) => {
    if (box.kcAlt) return box.kcAlt;
    const src = altUrl(box);
    if (!src) return Promise.reject(new Error('no photo'));
    box.kcAlt = new Promise((resolve, reject) => {
      const img = new Image();
      img.decoding = 'async';
      img.onload = () => resolve(src);
      img.onerror = () => reject(new Error('photo'));
      img.src = src;
    }).then((url) => {
      const link = box.querySelector('a');
      if (link && !link.querySelector('.kc4-card-alt')) {
        const layer = document.createElement('span');
        layer.className = 'kc4-card-alt';
        layer.setAttribute('aria-hidden', 'true');
        layer.style.backgroundImage = `url("${url.replace(/"/g, '%22')}")`;
        link.appendChild(layer);
      }
      return url;
    }).catch((e) => { box.kcAlt = null; throw e; });
    return box.kcAlt;
  };
  const showAlt = (box, on) => {
    const pill = box.querySelector('.kc4-card-count');
    if (!on) { box.classList.remove('is-alt'); if (pill) pill.textContent = '1/2'; return; }
    loadAlt(box).then(() => requestAnimationFrame(() => { box.classList.add('is-alt'); if (pill) pill.textContent = '2/2'; })).catch(() => {});
  };
  /* the warm-up exists only after the shopper's first swipe or pill tap: cards that sit ≥ 60 % in view for a second,
     while the page is idle; the slot is taken when the fetch is scheduled (a row of cards fires its timers together) */
  const warmObserver = (!fineHover && !lowData && 'IntersectionObserver' in window) ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const box = entry.target;
      clearTimeout(box.kcWarm);
      if (!entry.isIntersecting) return;
      box.kcWarm = setTimeout(() => {
        warmObserver.unobserve(box);
        if (box.kcAlt || warmed >= WARM_CAP) return;
        warmed += 1;
        (window.requestIdleCallback || ((fn) => setTimeout(fn, 200)))(() => { loadAlt(box).catch(() => {}); }, { timeout: 2000 });
        if (warmed >= WARM_CAP) altBoxes.forEach((other) => warmObserver.unobserve(other));
      }, 1000);
    });
  }, { threshold: 0.6 }) : null;
  const firstSwipe = () => {
    if (swipedOnce) return;
    swipedOnce = true;
    if (warmObserver) altBoxes.forEach((box) => { if (!box.kcAlt) warmObserver.observe(box); });
  };
  const decorateCard = (card) => {
    const box = card.querySelector('.kc4-card-image[data-kc-alt]');
    if (!box || box.dataset.kcAltReady) return;
    box.dataset.kcAltReady = '1';
    addUxStyles();
    const pill = document.createElement('span');
    pill.className = 'kc4-card-count';
    pill.setAttribute('aria-hidden', 'true');
    pill.textContent = '1/2';
    /* a press on the pill starts the fetch; the tap shows the photo */
    pill.addEventListener('pointerdown', () => { loadAlt(box).catch(() => {}); }, { passive: true });
    pill.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); firstSwipe(); showAlt(box, !box.classList.contains('is-alt')); });
    box.appendChild(pill);
    /* the card title's link is stretched over the whole card (::after, z-index 1): read the pointer on the card */
    if (fineHover) {
      let timer = 0;
      card.addEventListener('pointerenter', () => { clearTimeout(timer); timer = setTimeout(() => showAlt(box, true), 90); });
      card.addEventListener('pointerleave', () => { clearTimeout(timer); showAlt(box, false); });
      return;
    }
    card.classList.add('kc4-card--alt');
    altBoxes.add(box);
    let x0 = null;
    let y0 = 0;
    let swiped = false;
    let early = false;
    card.addEventListener('touchstart', (event) => {
      const p = event.touches[0];
      const r = box.getBoundingClientRect();
      swiped = false;
      early = false;
      x0 = p && p.clientX >= r.left && p.clientX <= r.right && p.clientY >= r.top && p.clientY <= r.bottom ? p.clientX : null;
      y0 = p ? p.clientY : 0;
    }, { passive: true });
    card.addEventListener('touchmove', (event) => {
      if (x0 == null || swiped) return;
      const p = event.touches[0];
      const dx = p.clientX - x0;
      const dy = p.clientY - y0;
      const sideways = Math.abs(dx) > Math.abs(dy) * 1.4;
      /* the first sideways move is the intent: the photo starts loading before the swipe completes (a vertical
         scroll that starts on a photo fetches nothing) */
      if (!early && sideways && Math.abs(dx) >= 10) { early = true; loadAlt(box).catch(() => {}); }
      if (Math.abs(dx) > 34 && sideways) { swiped = true; firstSwipe(); showAlt(box, !box.classList.contains('is-alt')); }
    }, { passive: true });
    card.addEventListener('touchend', () => { x0 = null; setTimeout(() => { swiped = false; }, 450); }, { passive: true });
    card.addEventListener('click', (event) => { if (swiped) { event.preventDefault(); event.stopPropagation(); swiped = false; } }, true);
    if (warmObserver && swipedOnce && warmed < WARM_CAP) warmObserver.observe(box);
  };

  /* ---------- UX-03: an understood search as one card (the search page) ---------- */
  const SHAPE_NAMES = { L: ['L-shape', 'حرف ال'], U: ['U-shape', 'حرف يو'], chaise: ['With chaise', 'مع شيزلونج'], straight: ['Straight', 'مستقيم'] };
  const arCount = (n, one, two, few, many) => { const m = n % 100; if (n === 1) return one; if (n === 2) return two; if (m >= 3 && m <= 10) return `${n} ${few}`; return `${n} ${many}`; };
  /* UXR-04: the card never links to an empty list. A query with filters waits for the index (the session copy, else one
     download, as the predictive search makes), so the attribute layer can relax what would empty the list. */
  const filtersOf = (u) => u.f || { shape: u.shape, seats: u.seatsFilter, bed: u.bed, width: u.width, price: u.price };
  /* seo-growth W6T (T6): a search line's English amounts (the list's travelling line, the search page's card) in the page's
     own price markup (the riyal glyph, as the cards and the list's "From" line show them), read the way the search dialog
     writes them: "SAR 6,120, above SAR 3,000." Left as text, assets/klik-saudi-riyal.js turned each "SAR 6,120" into the
     card markup, whose hidden " SAR " after the amount read "6,120 SAR , above 3,000 SAR ." Here the hidden currency comes
     first and the amount is the price box's own text, so neither the text nor the rendered text has a gap before the comma
     or full stop (the converter skips .klik-riyal-price). Arabic lines stay text («6,120 ريال»: the converter has no Arabic
     riyal token, as with the list's own «تبدأ الأسعار من …» line). */
  const lineText = (line, text) => {
    if (AR) { line.textContent = text; return; }
    const re = /\bSAR (\d+(?:,\d{3})*(?:\.\d{1,2})?)/g;
    let at = 0;
    for (let m = re.exec(text); m; m = re.exec(text)) {
      if (m.index > at) line.append(text.slice(at, m.index));
      const price = document.createElement('span');
      price.className = 'klik-riyal-price';
      price.dir = 'ltr';
      const currency = document.createElement('span');
      currency.className = 'visually-hidden';
      currency.textContent = 'SAR ';
      const sign = document.createElement('span');
      sign.className = 'klik-riyal-symbol';
      sign.setAttribute('aria-hidden', 'true');
      price.append(currency, sign, m[1]);
      line.append(price);
      at = m.index + m[0].length;
    }
    if (at < text.length) line.append(text.slice(at));
  };
  const understoodCard = (page, terms) => {
    if (!terms || !window.KlikSearch || typeof KlikSearch.loadAttrs !== 'function') return;
    KlikSearch.loadAttrs().then(() => {
      const first = KlikSearch.understand(terms);
      if (!first || !first.info) return null;
      const f0 = filtersOf(first);
      const needsIndex = Boolean(f0.shape || f0.seats || f0.bed || f0.width || f0.price || first.chairs) && !(KlikSearch.peek && KlikSearch.peek());
      return (needsIndex && typeof KlikSearch.index === 'function' ? KlikSearch.index().catch(() => null) : Promise.resolve(null)).then(() => KlikSearch.understand(terms));
    }).then((u) => {
      if (!u || !u.info || page.querySelector('.kc4-understood')) return;
      const money = (v) => Number(v).toLocaleString('en-US');
      const f = filtersOf(u);
      const bits = [AR ? u.info.label.ar : u.info.label.en];
      if (f.shape && SHAPE_NAMES[f.shape]) bits.push(t(SHAPE_NAMES[f.shape][0], SHAPE_NAMES[f.shape][1]));
      if (f.seats && u.chairs) bits.push(AR ? arCount(f.seats, 'كرسي واحد', 'كرسيان', 'كراسي', 'كرسيًا') : `${f.seats} chairs`);
      else if (f.seats) bits.push(AR ? arCount(f.seats, 'مقعد واحد', 'مقعدان', 'مقاعد', 'مقعدًا') : `${f.seats} seats`);
      if (f.bed) bits.push(t(`\u2066${f.bed.replace('x', ' × ')}\u2069 bed`, `سرير \u2066${f.bed.replace('x', ' × ')}\u2069`));
      if (f.width) bits.push(t(`about ${u.size} cm wide`, `بعرض نحو ${u.size} سم`));
      if (f.price) {
        if (f.price[1] == null) bits.push(t(`over SAR ${money(f.price[0])}`, `أكثر من ${money(f.price[0])} ريال`));
        else if (!f.price[0]) bits.push(t(`up to SAR ${money(f.price[1])}`, `حتى ${money(f.price[1])} ريال`));
        else bits.push(t(`SAR ${money(f.price[0])}–${money(f.price[1])}`, `${money(f.price[0])}–${money(f.price[1])} ريال`));
      }
      if (u.order === 'price-asc') bits.push(t('lowest price first', 'الأقل سعرًا أولًا'));
      else if (u.order === 'price-desc') bits.push(t('highest price first', 'الأعلى سعرًا أولًا'));
      const card = document.createElement('a');
      card.className = 'kc4-help-card kc4-understood';
      card.href = window.KlikStorefrontURL ? window.KlikStorefrontURL(u.info.url) : u.info.url;
      if (u.info.note && typeof KlikSearch.stashNote === 'function') card.addEventListener('click', () => KlikSearch.stashNote(u.info.url, u.info.note));
      card.innerHTML = '<span class="kc4-help-card-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="M4 7h10M18 7h2M4 17h4M12 17h8"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/></svg></span><span class="kc4-help-card-copy"><span class="kc4-help-card-title"></span><span class="kc4-help-card-note"></span></span><svg class="klik-icon-arrow klik-icon-arrow--forward" aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14m-6-6 6 6-6 6"/></svg>';
      card.querySelector('.kc4-help-card-title').textContent = bits.join(' · ');
      lineText(card.querySelector('.kc4-help-card-note'), u.note || t('Open the list with these filters', 'افتح القائمة بهذه الفلاتر'));
      const form = page.querySelector('.kc4-search-form');
      if (form) form.after(card); else page.prepend(card);
    }).catch(() => { /* the page stays as it is */ });
  };

  document.querySelectorAll('[data-catalogue]').forEach((root) => {
    if (root.dataset.catalogueReady) return;
    root.dataset.catalogueReady = 'true';
    /* UXR-08: every list gets the frame rule, also lists whose cards have no second photo (bedroom pieces, benches) */
    addUxStyles();
    const $ = (selector) => root.querySelector(selector);
    const isSearch = root.hasAttribute('data-kc-search-query');
    const searchTerms = root.dataset.kcSearchTerms || root.dataset.kcSearchQuery || '';
    const sectionId = root.dataset.catalogue;
    const grid = $('[data-kc-grid]');
    const pager = $('[data-kc-pagination]');
    const status = $('[data-kc-status]');
    const resultBar = $('[data-kc-result-bar]');
    const loadNote = $('[data-kc-loading]');
    const field = $('[data-kc-search]');
    const typeSel = $('[data-kc-type]');
    const modeSel = $('[data-kc-delivery]');
    const sortSel = $('[data-kc-sort]');
    const tools = $('[data-catalogue-tools]');
    const toggle = $('[data-kc-filter-toggle]');
    const sheet = $('[data-kc-sheet]');
    const sheetBody = $('[data-kc-sheet-body]');
    const refinements = $('[data-kc-refinements]');
    const applyBtn = $('[data-kc-sheet-apply]');
    const facets = $('[data-kc-facets]');
    const kfacetsBox = facets ? null : $('[data-kc-kfacets]');
    const filterCount = $('[data-kc-filter-count]');
    const empty = $('[data-kc-empty]');
    const savedCount = $('[data-kc-saved-count]');
    const shortlistBtn = $('[data-kc-shortlist]');
    const printBtn = $('[data-kc-print]');
    const chips = $('[data-kc-chips]');
    const tabs = $('[data-kc-tabs]');
    const paths = $('[data-kc-paths]');
    const countNodes = root.querySelectorAll('[data-kc-count]');
    const actions = $('[data-kc-actions]');
    const fixedMode = root.dataset.kcFixedAvailability || '';
    const defaultSort = root.dataset.kcDefaultSort || 'featured';
    const first = JSON.parse(($('[data-kc-page]') || {}).textContent || '{}');
    const pages = Math.max(1, Number(first.pages) || 1);
    const firstPage = Math.max(1, Number(first.page) || 1);
    let serverCount = Number(first.count != null ? first.count : first.total) || 0;
    /* false on a free-text search with more than one page until the exact count arrives (main-search.liquid count view) */
    let countExact = first.exact !== false;
    const countLabel = () => (countExact ? designs(serverCount) : t('Matching designs', 'كل التصاميم المطابقة'));
    const collator = new Intl.Collator(AR ? 'ar' : 'en');

    /* the place to come back to: history.state first, sessionStorage as the fallback (some scripts replace the state) */
    const RESTORE_KEY = 'klik:kc-place';
    const savedPlace = (() => {
      if (navType !== 'back_forward') return null;
      let place = history.state && history.state.kc;
      if (!place) {
        try { place = JSON.parse(sessionStorage.getItem(RESTORE_KEY) || 'null'); } catch (e) { place = null; }
        if (place && Date.now() - (place.at || 0) > 30 * 60 * 1000) place = null;
      }
      return place && place.list === location.pathname ? place : null;
    })();
    if (savedPlace) {
      try { history.scrollRestoration = 'manual'; } catch (e) { /* older browsers */ }
    }

    /* ---------- the pool of cards ---------- */
    const pool = new Map();
    const loaded = new Set();
    /* the price the card shows (campaign applied), so a price chip matches the number on the card */
    const shownPrice = (card) => {
      const node = card.querySelector('[data-kprice-current]');
      const value = node ? Number(node.dataset.kpriceCurrent) : 0;
      return (value > 0 ? value : Number(card.dataset.kcBaseTotal || 0)) / 100;
    };
    const addCards = (scope, page) => {
      scope.querySelectorAll('[data-kc-product]').forEach((card, index) => {
        const id = card.dataset.kcProduct;
        if (pool.has(id)) return;
        const title = card.querySelector('.kc4-card-title, h2, h3');
        const name = (title ? title.textContent : '').trim();
        const button = card.querySelector('[data-kc-save]');
        if (button) button.hidden = false;
        decorateCard(card);
        pool.set(id, {
          id, card, button, name,
          search: fold(`${name} ${card.dataset.kcName || ''} ${card.dataset.kcHandle ? card.dataset.kcHandle.replace(/-/g, ' ') : ''}`),
          price: Number(card.dataset.kcBaseTotal || 0) / 100,
          category: card.dataset.kcCategory,
          kind: card.dataset.kcKind,
          created: Number(card.dataset.kcCreated || 0),
          rank: Number(card.dataset.kcRank || 1),
          twinHidden: card.hasAttribute('data-kc-twin-hidden'),
          twin: card.dataset.kcTwin || '',
          shape: card.dataset.kcShape || '',
          seats: Number(card.dataset.kcSeats || 0),
          width: Number(card.dataset.kcWidth || 0),
          piece: card.dataset.kcPiece || '',
          options: (card.dataset.kcSeatOptions || '').split(',').map(Number).filter((n) => n > 0),
          beds: (card.dataset.kcBeds || '').split(',').filter(Boolean),
          table: card.dataset.kcTable || '',
          shown: shownPrice(card),
          page, index,
        });
      });
      loaded.add(page);
      /* a design-name search (main-search.liquid) lists the design in both buying modes on purpose */
      if (isSearch && !root.hasAttribute('data-kc-design-query')) collapseTwins(page);
    };
    /* One card per twin pair on search pages (K-008). On one server page the made-to-order card stands for its ready twin
       (main-search.liquid). Across pages the card that comes first in the server order stands for the pair, so a page
       that arrives later never takes away a card the shopper has already seen (K-028); the count follows. */
    const collapseTwins = (page) => {
      const namedBy = new Map();
      pool.forEach((entry) => { if (entry.twin) namedBy.set(entry.twin, entry); });
      const later = (a, b) => a.page - b.page || a.index - b.index;
      pool.forEach((entry) => {
        if (entry.page !== page || entry.twinHidden) return;
        const partner = (entry.twin && pool.get(entry.twin)) || namedBy.get(entry.id);
        if (!partner || partner === entry || partner.twinHidden || partner.kind === entry.kind) return;
        const drop = later(entry, partner) > 0 ? entry : partner;
        drop.twinHidden = true;
        drop.card.setAttribute('data-kc-twin-hidden', '');
        if (!countExact) serverCount = Math.max(0, serverCount - 1);
      });
    };
    addCards(grid, firstPage);

    /* ---------- state (from the address, so a shared or reloaded link keeps its view) ---------- */
    const params = new URL(location.href).searchParams;
    const searchType = isSearch ? params.get('type') : null;
    const typeKey = isSearch ? 'furniture' : 'type';
    let saved = new Set(readSaved().map((item) => String(item.id)));
    let savedOnly = params.get('saved') === '1';
    let sortChosen = false;
    const kpage = Number(params.get('kpage'));
    let limit = PER * (Number.isSafeInteger(kpage) && kpage > 1 ? kpage : 1);
    if (field) field.value = params.get('kq') || '';
    if (typeSel && [...typeSel.options].some((o) => o.value === params.get(typeKey))) typeSel.value = params.get(typeKey);
    if (modeSel && [...modeSel.options].some((o) => o.value === params.get('availability'))) modeSel.value = params.get('availability');
    if (sortSel) {
      if ([...sortSel.options].some((o) => o.value === params.get('order'))) { sortSel.value = params.get('order'); sortChosen = true; }
      else sortSel.value = defaultSort;
    }
    /* client facets (v3): Shape / Seats / Width / Price chips built from the cards; within a group any chosen value,
       across groups every group. Values: shape L|U|chaise|straight, seats "6" or "9+", width and price "lo-hi" */
    const FACET_KEYS = ['shape', 'seats', 'bed', 'table', 'width', 'price'];
    const picked = { shape: new Set(), seats: new Set(), bed: new Set(), table: new Set(), width: new Set(), price: new Set() };
    if (kfacetsBox) FACET_KEYS.forEach((key) => { (params.get(key) || '').split(',').filter(Boolean).forEach((value) => picked[key].add(value)); });
    const facetCount = () => FACET_KEYS.reduce((n, key) => n + picked[key].size, 0);
    /* "lo-hi": above lo, up to and including hi ("0-300" = up to 300; "350-" = over 350) */
    const inRange = (value, id) => {
      const [lo, hi] = String(id).split('-');
      return value > 0 && value > (Number(lo) || 0) && (hi === '' || hi == null ? true : value <= Number(hi));
    };
    const facetMatch = (entry, key, value) => {
      if (key === 'shape') return entry.shape === value;
      if (key === 'seats') {
        /* what can be ordered: the pictured seats plus the card's seat options (a ready set's 11-Seater variant) */
        const n = Number(String(value).replace(/\+$/, ''));
        const all = [entry.seats].concat(entry.options || []).filter((v) => v > 0);
        return /\+$/.test(value) ? all.some((v) => v >= n) : all.includes(n);
      }
      if (key === 'bed') return Boolean(entry.beds && entry.beds.includes(value));
      if (key === 'table') return entry.table === value;
      if (key === 'width') return inRange(entry.width, value);
      if (key === 'price') return inRange(entry.shown, value);
      return true;
    };
    const passFacets = (entry, skip) => FACET_KEYS.every((key) => key === skip || !picked[key].size || [...picked[key]].some((value) => facetMatch(entry, key, value)));
    const modeValue = () => fixedMode || (modeSel ? modeSel.value : 'all');
    const typeValue = () => (typeSel ? typeSel.value : 'all');
    const sortValue = () => (sortSel ? sortSel.value : defaultSort);
    const query = () => (field ? field.value.trim() : '');
    const isDefault = () => !query() && typeValue() === 'all' && (fixedMode || modeValue() === 'all') && sortValue() === defaultSort && !savedOnly && !facetCount();
    const activeFilters = () => (query() ? 1 : 0) + (typeValue() !== 'all' ? 1 : 0) + (!fixedMode && modeValue() !== 'all' ? 1 : 0)
      + (facets ? facets.querySelectorAll('input:checked').length : 0) + facetCount();

    /* ---------- loading further server pages ---------- */
    let failed = false;
    const pageUrl = (page) => {
      const url = new URL(location.href);
      ['kpage', 'kq', 'type', 'furniture', 'availability', 'order', 'saved', 'colour', ...FACET_KEYS].forEach((key) => url.searchParams.delete(key));
      url.searchParams.set('page', String(page));
      url.searchParams.set('section_id', sectionId);
      /* search: the same result set as page 1 (the site's forms send type=product; an older link may not) */
      if (isSearch && searchType) url.searchParams.set('type', searchType);
      return url;
    };
    const fetchPage = async (page) => {
      if (loaded.has(page)) return;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(pageUrl(page), { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw new Error(`Catalogue page ${page}: ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = doc.querySelector('[data-kc-page]');
        if (!data) throw new Error('Catalogue page missing');
        if (loaded.has(page)) return;
        const info = JSON.parse(data.textContent || '{}');
        const leftOut = (Number(info.hidden) || 0) + (Number(info.others) || 0);
        if (isSearch && !countExact && leftOut > 0) serverCount = Math.max(0, serverCount - leftOut);
        addCards(doc.querySelector('[data-kc-grid]') || doc, page);
      } finally { clearTimeout(timer); }
    };
    const allLoaded = () => { for (let p = 1; p <= pages; p++) if (!loaded.has(p)) return false; return true; };
    let loadingAll = null;
    const loadAll = () => {
      if (allLoaded()) return Promise.resolve();
      if (loadingAll) return loadingAll;
      failed = false;
      const todo = [];
      for (let p = 1; p <= pages; p++) if (!loaded.has(p)) todo.push(p);
      let next = 0;
      const worker = async () => { while (next < todo.length) { const p = todo[next++]; await fetchPage(p); } };
      showLoading(true);
      loadingAll = Promise.all([worker(), worker(), worker()])
        .catch(() => { failed = true; })
        .finally(() => { loadingAll = null; showLoading(false); render(); });
      return loadingAll;
    };
    const showLoading = (on) => {
      if (!loadNote) return;
      loadNote.replaceChildren();
      if (on) {
        loadNote.hidden = false;
        loadNote.textContent = countExact ? t(`Loading all ${designs(serverCount)}…`, `جارٍ تحميل ${designs(serverCount)}…`) : t('Loading all designs…', 'جارٍ تحميل كل التصاميم…');
      } else if (failed) {
        loadNote.hidden = false;
        loadNote.append(t('Some designs could not load. ', 'تعذّر تحميل بعض التصاميم. '));
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.textContent = t('Try again', 'حاول مرة أخرى');
        retry.addEventListener('click', () => { loadAll(); });
        loadNote.append(retry);
      } else {
        loadNote.hidden = true;
      }
    };

    /* ---------- filter and order ---------- */
    const baseFilter = () => {
      const words = fold(query()).split(' ').filter(Boolean);
      const mode = modeValue();
      const type = typeValue();
      return (entry) => {
        /* a hidden twin comes back when its buying mode is chosen (its partner is the other mode) */
        if (entry.twinHidden && mode === 'all') return false;
        if (type !== 'all' && entry.category !== type) return false;
        if (mode !== 'all' && entry.kind !== mode) return false;
        if (savedOnly && !saved.has(entry.id)) return false;
        return words.every((word) => entry.search.includes(word));
      };
    };
    const compute = () => {
      const base = baseFilter();
      const list = [...pool.values()].filter((entry) => base(entry) && passFacets(entry));
      const order = sortValue();
      const byServer = (a, b) => a.page - b.page || a.index - b.index;
      const priced = (entry, high) => (entry.price > 0 ? entry.price : high ? -1 : Infinity);
      if (order === 'name') list.sort((a, b) => collator.compare(a.name, b.name) || byServer(a, b));
      else if (order === 'newest' && order !== defaultSort) list.sort((a, b) => b.created - a.created || byServer(a, b));
      else if (order === 'price-asc') list.sort((a, b) => priced(a) - priced(b) || byServer(a, b));
      else if (order === 'price-desc') list.sort((a, b) => priced(b, true) - priced(a, true) || byServer(a, b));
      else if (order === 'featured' && !isSearch) list.sort((a, b) => a.page - b.page || b.rank - a.rank || a.index - b.index);
      else list.sort(byServer);
      return list;
    };

    /* ---------- render ---------- */
    /* the server already shows page 1 in its order: the first render leaves those cards where they are */
    let shownKey = [...grid.querySelectorAll('[data-kc-product]:not([hidden])')].map((card) => card.dataset.kcProduct).join(',');
    let pagerKey = '';
    let lastFilterKey = '';
    let filterTimer;
    /* UXR-04 safety net: filters from the address (a shared link, a direct visit, Enter before the search index was in the
       tab) that leave no design. The empty state says what the list does have, built from its own cards (prices as the
       cards show them), and one navy button takes the shopper there: the lowest prices first, every bed size or every
       chair count. "Show the whole collection" stays the one text link (PACKAGES 1.13). */
    let emptyWhy = null;
    const moneyText = (riyals) => {
      const cents = Math.round(Number(riyals) * 100);
      try { if (window.KlikMoney && typeof KlikMoney.text === 'function') return KlikMoney.text(cents); } catch (e) { /* plain text below */ }
      const v = cents / 100;
      const amount = v % 1 ? v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : v.toLocaleString('en-US');
      return t(`SAR ${amount}`, `${amount} ريال`);
    };
    const canSort = (value) => Boolean(sortSel && [...sortSel.options].some((o) => o.value === value));
    const explainEmpty = (count, filtered, loading) => {
      if (!empty) return;
      const generic = empty.querySelector('p:not(.kc4-empty-why)');
      const keys = FACET_KEYS.filter((key) => picked[key].size);
      let plan = null;
      if (!count && filtered && !loading && allLoaded() && keys.length && !query() && !savedOnly) {
        const ready = [...pool.values()].filter(baseFilter());
        for (const key of ['price', 'bed', 'seats', 'table', 'width', 'shape']) {
          if (!keys.includes(key)) continue;
          const rest = ready.filter((entry) => passFacets(entry, key));
          if (rest.length) { plan = { key, rest }; break; }
        }
      }
      if (!plan) {
        if (emptyWhy) emptyWhy.hidden = true;
        if (generic) generic.hidden = false;
        return;
      }
      let text = '';
      let action = '';
      let order = '';
      if (plan.key === 'price') {
        const values = plan.rest.map((entry) => entry.shown).filter((v) => v > 0);
        const lo = Math.min(...values);
        const hi = Math.max(...values);
        const ranges = [...picked.price].map((id) => String(id).split('-'));
        const top = ranges.some((r) => r[1] === '' || r[1] == null) ? Infinity : Math.max(...ranges.map((r) => Number(r[1]) || 0));
        const bottom = Math.min(...ranges.map((r) => Number(r[0]) || 0));
        if (values.length && lo > top) {
          text = t(`Prices here start from ${moneyText(lo)}.`, `تبدأ الأسعار هنا من ${moneyText(lo)}.`);
          action = t('See the most affordable', 'اعرض الأقل سعرًا');
          order = 'price-asc';
        } else if (values.length && hi <= bottom) {
          text = t(`Prices here go up to ${moneyText(hi)}.`, `أعلى سعر هنا ${moneyText(hi)}.`);
          action = t('See the highest priced', 'اعرض الأعلى سعرًا');
          order = 'price-desc';
        } else {
          text = t('Nothing here in this price range right now.', 'لا يوجد هنا ما يقع في هذا النطاق السعري حاليًا.');
          action = t('Clear the price filter', 'امسح فلتر السعر');
          order = 'price-asc';
        }
      } else if (plan.key === 'bed') {
        const beds = [...new Set(plan.rest.reduce((list, entry) => list.concat(entry.beds), []))].sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
        text = t(`Bed sizes here: ${beds.map((b) => facetLabel('bed', b)).join(', ')}.`, `مقاسات السرير المتوفرة هنا: ${beds.map((b) => facetLabel('bed', b)).join('، ')}.`);
        action = t('Show every bed size', 'اعرض كل المقاسات');
      } else if (plan.key === 'seats') {
        const counts = [...new Set(plan.rest.reduce((list, entry) => list.concat([entry.seats], entry.options), []).filter((n) => n > 0))].sort((a, b) => a - b);
        text = chairsOnly ? t(`Chair counts here: ${counts.join(', ')}.`, `عدد الكراسي المتوفر هنا: ${counts.join('، ')}.`)
          : t(`Seat counts here: ${counts.join(', ')}.`, `عدد المقاعد المتوفر هنا: ${counts.join('، ')}.`);
        action = chairsOnly ? t('Show every chair count', 'اعرض كل الأعداد') : t('Show every seat count', 'اعرض كل الأعداد');
      } else {
        const def = (facetDefs || []).find((d) => d.key === plan.key);
        const label = def ? def.label : '';
        text = label ? t(`${designs(plan.rest.length)} without the “${label}” filter.`, `${designs(plan.rest.length)} بدون فلتر «${label}».`) : t(`${designs(plan.rest.length)} without this filter.`, `${designs(plan.rest.length)} بدون هذا الفلتر.`);
        action = t('Clear this filter', 'امسح هذا الفلتر');
      }
      if (order && !canSort(order)) order = '';
      const sig = [plan.key, text, action, order, location.search].join('|');
      if (emptyWhy && emptyWhy.dataset.sig === sig && !emptyWhy.hidden) return;
      if (!emptyWhy) {
        emptyWhy = document.createElement('p');
        emptyWhy.className = 'kc4-empty-why';
        const reset = empty.querySelector('[data-kc-reset]');
        if (reset) reset.before(emptyWhy); else empty.append(emptyWhy);
      }
      const href = new URL(location.href);
      href.searchParams.delete(plan.key);
      if (order) href.searchParams.set('order', order);
      const link = document.createElement('a');
      link.className = 'kc4-empty-alt';
      link.href = href.pathname + href.search;
      link.textContent = action;
      const key = plan.key;
      link.addEventListener('click', (event) => {
        event.preventDefault();
        picked[key].clear();
        if (order) { sortSel.value = order; sortChosen = true; }
        changed();
        requestAnimationFrame(() => { const first = grid.querySelector('.kc4-card-title a'); if (first) first.focus(); });
      });
      emptyWhy.replaceChildren(document.createTextNode(`${text} `), link);
      emptyWhy.dataset.sig = sig;
      emptyWhy.hidden = false;
      if (generic) generic.hidden = true;
    };
    const render = () => {
      /* dining lists say "6 chairs" from the first paint (the address pill too), not only once the facets are built */
      if (!facetDefs) chairsOnly = onlyDining();
      const list = compute();
      const filtered = !isDefault();
      /* once every page is here, the list itself is the count (Shopify's search count can differ by a design or two
         from the results it returns, and twins on later pages are only known when they arrive) */
      if (isSearch && !filtered && allLoaded() && !loadingAll) serverCount = list.length;
      const total = filtered ? list.length : serverCount;
      const shown = list.slice(0, limit);
      const key = shown.map((entry) => entry.id).join(',');
      if (key !== shownKey) {
        shown.forEach((entry) => { entry.card.hidden = false; });
        grid.replaceChildren(...shown.map((entry) => entry.card));
        shownKey = key;
      }
      shown.forEach((entry) => {
        if (entry.button) {
          const on = saved.has(entry.id);
          if (entry.button.getAttribute('aria-pressed') !== String(on)) entry.button.setAttribute('aria-pressed', String(on));
        }
      });
      const loading = Boolean(loadingAll);
      if (empty) empty.hidden = list.length > 0 || loading || !filtered;
      explainEmpty(list.length, filtered, loading);
      countNodes.forEach((node) => setText(node, countLabel()));
      setText(status, loading ? t('Loading…', 'جارٍ التحميل…') : filtered ? designs(total) : countLabel());
      root.querySelectorAll('[data-kc-mode-filter]').forEach((link) => {
        if (link.dataset.kcModeFilter === modeValue()) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
      });
      if (resultBar) {
        const active = activeFilters() > 0 || savedOnly || saved.size > 0;
        if (active) resultBar.setAttribute('data-kc-active', ''); else resultBar.removeAttribute('data-kc-active');
      }
      if (savedCount) setText(savedCount, String(saved.size));
      if (shortlistBtn) {
        shortlistBtn.hidden = !saved.size && !savedOnly;
        shortlistBtn.setAttribute('aria-pressed', String(savedOnly));
      }
      if (printBtn) printBtn.hidden = !savedOnly || !list.length;
      root.querySelectorAll('.kc4-result-bar [data-kc-reset]').forEach((button) => { button.hidden = !filtered || (sortChosen && activeFilters() === 0 && !savedOnly); });
      if (actions) actions.hidden = false;
      const count = activeFilters();
      if (filterCount) { filterCount.hidden = count === 0; setText(filterCount, String(count)); }
      if (applyBtn && !applyBtn.dataset.kcFacetUrl) setText(applyBtn, loading ? t('Loading…', 'جارٍ التحميل…') : !filtered && !countExact ? t('Show designs', 'عرض التصاميم') : t(`Show ${designs(total)}`, `عرض ${designs(total)}`));
      renderChips();
      renderFacets();
      renderPager(shown.length, total, list.length > shown.length || (!filtered && !allLoaded()), filtered || countExact);
      renderPaths();
      writeUrl();
      if (isSearch) {
        document.title = countExact
          ? t(`Search: ${designs(serverCount)} for “${searchTerms}” | ${siteName()}`, `البحث عن «${searchTerms}»: ${designs(serverCount)} | ${siteName()}`)
          : t(`Search: “${searchTerms}” | ${siteName()}`, `البحث عن «${searchTerms}» | ${siteName()}`);
      }
      const filterKey = [query(), typeValue(), modeValue(), sortValue(), savedOnly, ...FACET_KEYS.map((key) => [...picked[key]].join(','))].join('|');
      if (filterKey !== lastFilterKey) {
        const announce = lastFilterKey !== '';
        lastFilterKey = filterKey;
        clearTimeout(filterTimer);
        if (announce && !loading) {
          filterTimer = setTimeout(() => publish('klik_catalog_filtered', {
            list: root.dataset.kcHandle || (isSearch ? 'search' : ''), q: query() || null, type: typeValue(), mode: modeValue(),
            sort: sortValue(), saved: savedOnly, results: total, lang: AR ? 'ar' : 'en',
            facets: FACET_KEYS.filter((key) => picked[key].size).map((key) => `${key}:${[...picked[key]].join(',')}`).join(';') || null,
          }), 800);
        }
      }
    };

    /* "Show more" stays while cards are waiting or server pages are still to come */
    const renderPager = (shownCount, total, more, exact) => {
      if (!pager) return;
      const of = Math.max(total, shownCount);
      const key = `${shownCount}:${of}:${more}:${exact}`;
      if (key === pagerKey) return;
      pagerKey = key;
      pager.replaceChildren();
      pager.hidden = !(of > 0 && (more || shownCount > PER));
      if (pager.hidden) return;
      const wrap = document.createElement('div');
      wrap.className = 'kc4-more';
      const line = document.createElement('p');
      line.textContent = exact ? t(`Showing ${shownCount} of ${of}`, `عرض ${shownCount} من ${of}`) : t(`Showing ${designs(shownCount)}`, `عرض ${designs(shownCount)}`);
      wrap.append(line);
      if (exact) {
        const bar = document.createElement('span');
        bar.className = 'kc4-more-bar';
        bar.style.setProperty('--kc4-progress', `${Math.min(100, Math.round((shownCount / Math.max(1, of)) * 100))}%`);
        wrap.append(bar);
      }
      if (more) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kc4-more-button';
        button.textContent = t('Show more designs', 'عرض المزيد من التصاميم');
        button.addEventListener('click', () => showMore(button));
        wrap.append(button);
      }
      pager.append(wrap);
    };

    const showMore = async (button) => {
      const before = Math.min(limit, compute().length);
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      try {
        if (isDefault()) {
          /* a full step of designs: a page that carries hidden twins is topped up from the next one */
          let next = Math.max(...loaded) + 1;
          while (compute().length < limit + PER && next <= pages) { await fetchPage(next); next += 1; }
        } else {
          await loadAll();
        }
      } catch (e) {
        failed = true;
        showLoading(false);
      }
      limit += PER;
      render();
      const focusTarget = grid.children[before] && grid.children[before].querySelector('.kc4-card-title a, a');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    };

    const renderChips = () => {
      if (!chips) return;
      const list = [];
      if (query()) list.push(['search', `“${query()}”`]);
      if (typeSel && typeValue() !== 'all') list.push(['type', typeSel.options[typeSel.selectedIndex].textContent]);
      if (modeSel && !fixedMode && modeValue() !== 'all') list.push(['mode', modeSel.options[modeSel.selectedIndex].textContent]);
      if (savedOnly) list.push(['saved', t('Saved', 'المحفوظات')]);
      FACET_KEYS.forEach((fkey) => picked[fkey].forEach((value) => list.push([`facet:${fkey}:${value}`, facetLabel(fkey, value)])));
      const key = list.map((item) => item.join(':')).join('|');
      if (chips.dataset.key === key) return;
      chips.dataset.key = key;
      chips.replaceChildren(...list.map(([kind, label]) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'kc4-chip';
        chip.setAttribute('aria-label', t(`Remove filter: ${label}`, `إزالة الفلتر: ${label}`));
        chip.innerHTML = '<span></span><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';
        chip.firstChild.textContent = label;
        chip.addEventListener('click', () => {
          if (kind === 'search' && field) field.value = '';
          if (kind === 'type' && typeSel) typeSel.value = 'all';
          if (kind === 'mode' && modeSel) modeSel.value = 'all';
          if (kind === 'saved') savedOnly = false;
          if (kind.indexOf('facet:') === 0) { const [, fkey, ...rest] = kind.split(':'); picked[fkey].delete(rest.join(':')); }
          limit = PER;
          render();
        });
        return chip;
      }));
      chips.hidden = !list.length;
    };

    /* ---------- client facets (v3 conversion fix): Shape / Seats / Width / Price chips with live counts ---------- */
    const SHAPES = { L: ['L-shape', 'حرف ال'], U: ['U-shape', 'حرف يو'], chaise: ['With chaise', 'مع شيزلونج'], straight: ['Straight', 'مستقيم'] };
    const group = (n, one, two, few, many) => {
      if (!AR) return null;
      const m = n % 100;
      if (n === 1) return one;
      if (n === 2) return two;
      if (m >= 3 && m <= 10) return `${n} ${few}`;
      return `${n} ${many}`;
    };
    let chairsOnly = false;
    const onlyDining = () => {
      const seated = [...pool.values()].filter((entry) => entry.seats > 0 || entry.options.length);
      return seated.length > 0 && seated.every((entry) => entry.piece === 'dining_set');
    };
    const seatsText = (value) => {
      const open = /\+$/.test(value);
      const n = Number(open ? value.slice(0, -1) : value);
      if (chairsOnly) {
        const base = AR ? group(n, 'كرسي واحد', 'كرسيان', 'كراسي', 'كرسيًا') : (n === 1 ? '1 chair' : `${n} chairs`);
        return open ? t(`${base} or more`, `${base} أو أكثر`) : base;
      }
      const base = AR ? group(n, 'مقعد واحد', 'مقعدان', 'مقاعد', 'مقعدًا') : (n === 1 ? '1 seat' : `${n} seats`);
      return open ? t(`${base} or more`, `${base} أو أكثر`) : base;
    };
    const num = (n) => Number(n).toLocaleString('en-US');
    const rangeText = (id, unit) => {
      const [lo, hi] = String(id).split('-');
      const a = Number(lo) || 0;
      const money = unit === 'SAR';
      const v = (n) => (money ? t(`SAR ${num(n)}`, `${num(n)} ريال`) : t(`${num(n)} cm`, `${num(n)} سم`));
      if (!a && hi) return t(`Up to ${v(hi)}`, `حتى ${v(hi)}`);
      if (!hi) return t(`Over ${v(a)}`, `أكثر من ${v(a)}`);
      return money ? t(`SAR ${num(a)}–${num(hi)}`, `${num(a)}–${num(hi)} ريال`) : t(`${num(a)}–${num(hi)} cm`, `${num(a)}–${num(hi)} سم`);
    };
    const facetLabel = (key, value) => {
      if (key === 'shape') return SHAPES[value] ? t(SHAPES[value][0], SHAPES[value][1]) : value;
      if (key === 'seats') return seatsText(value);
      if (key === 'width') return rangeText(value, 'cm');
      if (key === 'price') return rangeText(value, 'SAR');
      if (key === 'bed') { const [w, l] = String(value).split('x'); return t(`\u2066${w} × ${l}\u2069 cm`, `\u2066${w} × ${l}\u2069 سم`); }
      if (key === 'table') return TABLES[value] ? t(TABLES[value][0], TABLES[value][1]) : value;
      return value;
    };
    const TABLES = { rectangle: ['Rectangular', 'مستطيلة'], round: ['Round', 'دائرية'], oval: ['Oval', 'بيضاوية'], square: ['Square', 'مربعة'], organic: ['Free-form', 'شكل حر'] };
    /* bucket edges at round numbers near the quartiles (or the median of a short list); empty buckets are dropped */
    const buckets = (values, step, plain) => {
      const list = values.filter((v) => v > 0).sort((a, b) => a - b);
      if (list.length < 4) return [];
      const lo0 = list[0];
      const hi0 = list[list.length - 1];
      /* sizes: every round step between the smallest and the largest when that gives at most four chips ("up to 3 m") */
      const steps = [];
      for (let edge = Math.ceil(lo0 / step) * step; edge < hi0; edge += step) steps.push(edge);
      const qs = list.length >= 16 ? [0.25, 0.5, 0.75] : [0.5];
      const edges = plain && steps.length && steps.length <= 3 ? steps
        : [...new Set(qs.map((q) => Math.round(list[Math.floor(q * (list.length - 1))] / step) * step))]
          .filter((edge) => edge >= lo0 && edge < hi0);
      const ids = [];
      let lo = 0;
      edges.forEach((edge) => { ids.push(`${lo}-${edge}`); lo = edge; });
      ids.push(`${lo}-`);
      const used = ids.filter((id) => list.some((v) => inRange(v, id)));
      return used.length >= 2 ? used : [];
    };
    let facetDefs = null;
    const buildFacets = () => {
      const all = [...pool.values()];
      const defs = [];
      const shapes = Object.keys(SHAPES).filter((shape) => all.some((entry) => entry.shape === shape));
      if (shapes.length >= 2) defs.push({ key: 'shape', label: t('Shape', 'الشكل'), values: shapes });
      /* a group only when a chip narrows the list (UX-11): a filter that keeps everything is noise */
      const narrows = (key, values) => values.some((value) => { const n = all.filter((entry) => facetMatch(entry, key, value)).length; return n > 0 && n < all.length; });
      /* seat chips come from the cards the list can show: a ready set hidden behind its made-to-order twin (/collections/all)
         would otherwise add an "11 seats" chip that can only ever count 0 there */
      const seated = all.filter((entry) => (entry.seats > 0 || entry.options.length) && !entry.twinHidden);
      chairsOnly = seated.length > 0 && seated.every((entry) => entry.piece === 'dining_set');
      let seats = [...new Set(seated.reduce((list, entry) => list.concat([entry.seats], entry.options), []).filter((n) => n > 0))].sort((a, b) => a - b).map(String);
      if (seats.length > 6) seats = seats.slice(0, 5).concat(`${seats[5]}+`);
      /* UXR-02: the hint is about the corner sofas shoppers can see. Made to order, they are made to length; ready to ship,
         they come in the size shown. Where dining sets supply Seats chips (mixed lists) there is no hint at all. */
      const corners = all.filter((entry) => entry.piece === 'corner_sofa' && !(entry.seats > 0) && !entry.twinHidden);
      const madeCorners = corners.some((entry) => entry.kind !== 'ready');
      const diningInSeats = seated.some((entry) => entry.piece === 'dining_set');
      const seatsHint = chairsOnly || diningInSeats || !corners.length ? '' : madeCorners
        ? t('Seat counts are for sofa sets. Made-to-order corner sofas are made to your length: set the size in 3D.', 'عدد المقاعد لأطقم الكنب فقط. أما كنب الزاوية حسب الطلب فيُفصَّل على الطول الذي تريده: حدّد المقاس بتقنية 3D.')
        : t('Seat counts are for sofa sets. Ready-to-ship corner sofas come in the size shown on each design.', 'عدد المقاعد لأطقم الكنب فقط. كنب الزاوية الجاهز يأتي بالمقاس الظاهر في كل تصميم.');
      if (seats.length >= 2 && narrows('seats', seats)) {
        defs.push({ key: 'seats', label: chairsOnly ? t('Chairs', 'الكراسي') : t('Seats', 'المقاعد'), values: seats, hint: seatsHint });
      } else if (seated.length && seated.every((entry) => entry.kind === 'ready' && entry.piece === 'sofa_set' && [7, 11].every((n) => n === entry.seats || entry.options.includes(n)))) {
        /* UXR-01: one line instead of chips only where every set is ready to ship and has both counts as variants */
        defs.push({ key: 'seats', label: t('Seats', 'المقاعد'), values: [], hint: t('Every set comes with 7 or 11 seats: choose on the design’s page.', 'كل طقم متوفر بـ7 أو 11 مقعدًا: اختر عدد المقاعد في صفحة التصميم.') });
      }
      const beds = [...new Set(all.reduce((list, entry) => list.concat(entry.beds), []))].sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
      if (beds.length >= 2 && narrows('bed', beds)) defs.push({ key: 'bed', label: t('Bed size', 'مقاس السرير'), values: beds });
      const tables = Object.keys(TABLES).filter((shape) => all.some((entry) => entry.table === shape));
      if (tables.length >= 2) defs.push({ key: 'table', label: t('Table shape', 'شكل الطاولة'), values: tables });
      const widths = buckets(all.map((entry) => entry.width), 50, true);
      const madeWidths = all.some((entry) => entry.width > 0 && entry.kind !== 'ready');
      if (widths.length) defs.push({ key: 'width', label: madeWidths ? t('Width as pictured', 'العرض كما في الصورة') : t('Width', 'العرض'), values: widths, hint: madeWidths ? t('Made to order: choose your size in 3D', 'تفصيل حسب الطلب: اختر مقاسك بتقنية 3D') : '' });
      const prices = all.map((entry) => entry.shown);
      const mid = prices.filter((v) => v > 0).sort((a, b) => a - b)[Math.floor(prices.length / 2)] || 0;
      const priceIds = buckets(prices, mid >= 6000 ? 1000 : mid >= 2000 ? 500 : mid >= 600 ? 100 : 50);
      if (priceIds.length) defs.push({ key: 'price', label: t('Price', 'السعر'), values: priceIds });
      /* a value chosen through the address that is not one of the chips still shows, so it can be removed */
      defs.forEach((def) => picked[def.key].forEach((value) => { if (!def.values.includes(value)) def.values.push(value); }));
      facetDefs = defs;
      kfacetsBox.replaceChildren();
      kfacetsBox.removeAttribute('aria-busy');
      if (!defs.length) { kfacetsBox.hidden = true; return; }
      defs.forEach((def) => {
        const set = document.createElement('fieldset');
        set.className = 'kc4-kfacet';
        const legend = document.createElement('legend');
        legend.textContent = def.label;
        set.append(legend);
        if (def.hint) {
          addUxStyles();
          const hint = document.createElement('p');
          hint.className = 'kc4-kfacet-hint';
          hint.textContent = def.hint;
          set.append(hint);
        }
        const row = document.createElement('div');
        row.className = 'kc4-kchips';
        def.values.forEach((value) => {
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'kc4-kchip';
          chip.dataset.kcFacet = def.key;
          chip.dataset.kcValue = value;
          chip.setAttribute('aria-pressed', String(picked[def.key].has(value)));
          const name = document.createElement('span');
          name.textContent = facetLabel(def.key, value);
          const count = document.createElement('span');
          count.className = 'kc4-kchip-n';
          chip.append(name, count);
          row.append(chip);
        });
        if (def.values.length) set.append(row);
        kfacetsBox.append(set);
      });
    };
    const renderFacets = () => {
      if (!kfacetsBox) return;
      if (!facetDefs) {
        if (!allLoaded() || loadingAll) return;
        buildFacets();
      }
      const base = baseFilter();
      const ready = [...pool.values()].filter(base);
      kfacetsBox.querySelectorAll('[data-kc-facet]').forEach((chip) => {
        const key = chip.dataset.kcFacet;
        const value = chip.dataset.kcValue;
        const on = picked[key].has(value);
        const n = ready.filter((entry) => passFacets(entry, key) && facetMatch(entry, key, value)).length;
        if (chip.getAttribute('aria-pressed') !== String(on)) chip.setAttribute('aria-pressed', String(on));
        setText(chip.lastChild, String(n));
        chip.disabled = n === 0 && !on;
      });
    };
    if (kfacetsBox) {
      kfacetsBox.addEventListener('click', (event) => {
        const chip = event.target.closest('[data-kc-facet]');
        if (!chip || chip.disabled) return;
        const set = picked[chip.dataset.kcFacet];
        if (set.has(chip.dataset.kcValue)) set.delete(chip.dataset.kcValue); else set.add(chip.dataset.kcValue);
        changed();
      });
    }
    const renderPaths = () => {
      if (!paths || !typeSel) return;
      const base = paths.dataset.defaultContext;
      let context = base;
      if (modeValue() === 'ready') context = 'ready';
      else if (['bedrooms', 'dining'].includes(typeValue())) context = typeValue();
      paths.querySelectorAll('[data-kc-path]').forEach((path) => { path.hidden = path.dataset.kcPath !== context; });
    };

    const writeUrl = () => {
      const url = new URL(location.href);
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      const values = {
        kq: query(),
        [typeKey]: typeValue() === 'all' ? '' : typeValue(),
        availability: fixedMode || modeValue() === 'all' ? '' : modeValue(),
        order: sortChosen && sortValue() !== defaultSort ? sortValue() : '',
        saved: savedOnly ? '1' : '',
        kpage: limit > PER ? String(Math.ceil(limit / PER)) : '',
      };
      FACET_KEYS.forEach((key) => { values[key] = [...picked[key]].join(','); });
      Object.entries(values).forEach(([key, value]) => { if (value) url.searchParams.set(key, value); else url.searchParams.delete(key); });
      if (url.href !== location.href) history.replaceState(history.state, '', url);
    };

    /* ---------- controls ---------- */
    const changed = () => {
      limit = PER;
      if (!isDefault() && !allLoaded()) { render(); loadAll(); } else render();
    };
    if (tools) {
      tools.hidden = false;
      tools.addEventListener('submit', (event) => event.preventDefault());
    }
    if (typeSel) typeSel.addEventListener('change', changed);
    if (modeSel && !fixedMode) modeSel.addEventListener('change', changed);
    if (modeSel && fixedMode) { modeSel.value = fixedMode; modeSel.disabled = true; }
    if (sortSel) sortSel.addEventListener('change', () => { sortChosen = true; changed(); });
    /* BS-7: the buying-mode chips of a mixed list filter it in place (without the script the link reloads with ?availability) */
    root.querySelectorAll('[data-kc-mode-filter]').forEach((link) => link.addEventListener('click', (event) => {
      if (!modeSel || fixedMode) return;
      event.preventDefault();
      const value = link.dataset.kcModeFilter;
      modeSel.value = modeSel.value === value ? 'all' : value;
      changed();
    }));
    let typing;
    if (field) field.addEventListener('input', () => { clearTimeout(typing); typing = setTimeout(changed, 150); });
    root.querySelectorAll('[data-kc-reset]').forEach((button) => button.addEventListener('click', () => {
      if (field) field.value = '';
      if (typeSel) typeSel.value = 'all';
      if (modeSel) modeSel.value = fixedMode || 'all';
      if (sortSel) sortSel.value = defaultSort;
      sortChosen = false;
      savedOnly = false;
      FACET_KEYS.forEach((key) => picked[key].clear());
      if (facets && facets.querySelector('input:checked')) {
        facets.querySelectorAll('input:checked').forEach((input) => { input.checked = false; });
        location.assign(facetUrl());
        return;
      }
      limit = PER;
      render();
    }));
    if (shortlistBtn) shortlistBtn.addEventListener('click', () => { savedOnly = !savedOnly; changed(); });
    if (printBtn) printBtn.addEventListener('click', () => {
      grid.replaceChildren(...compute().map((entry) => entry.card));
      shownKey = '';
      window.print();
      render();
    });

    /* saved shortlist (same store as the header "Saved") */
    grid.addEventListener('click', (event) => {
      const button = event.target.closest('[data-kc-save]');
      if (!button) return;
      event.preventDefault();
      const card = button.closest('[data-kc-product]');
      const id = card.dataset.kcProduct;
      const entry = pool.get(id);
      const list = readSaved().filter((item) => String(item.id) !== id);
      if (saved.has(id)) saved.delete(id);
      else {
        saved.add(id);
        const link = card.querySelector('.kc4-card-title a, h2 a, h3 a');
        const image = card.querySelector('img');
        list.unshift({ id, title: entry ? entry.name : '', url: link ? new URL(link.href).pathname : '', image: image ? image.currentSrc || image.src || '' : '', price: '' });
      }
      let stored = true;
      try { localStorage.setItem(SAVED_KEY, JSON.stringify(list)); } catch (e) { stored = false; }
      publish(saved.has(id) ? 'klik_product_saved' : 'klik_product_unsaved', { productId: id, handle: card.dataset.kcHandle || '' });
      render();
      if (stored) document.dispatchEvent(new CustomEvent('klik:saved-changed', { detail: { source: root } }));
    });
    const syncSaved = () => { saved = new Set(readSaved().map((item) => String(item.id))); render(); };
    document.addEventListener('klik:saved-changed', (event) => { if (!event.detail || event.detail.source !== root) syncSaved(); });
    window.addEventListener('storage', (event) => { if (event.key === SAVED_KEY) syncSaved(); });

    /* ---------- filter sheet ---------- */
    const phone = window.matchMedia('(max-width: 749px)');
    const refinementsHome = refinements ? refinements.parentNode : null;
    const refinementsNext = refinements ? refinements.nextSibling : null;
    /* phone lists with a chip row: the name search lives in the sheet (the filter button sits in the chip row) */
    const searchBox = root.hasAttribute('data-kc-compact') ? $('[data-kc-search-box]') : null;
    const searchHome = searchBox ? searchBox.parentNode : null;
    const searchNext = searchBox ? searchBox.nextSibling : null;
    /* phone: the sort fields and the name search live in the sheet from the first idle moment (they are hidden in the
       toolbar there), so opening the sheet moves no DOM and costs one style pass (AR open was 756 ms vs 251 ms EN) */
    const placeInSheet = () => {
      if (!phone.matches || !sheetBody) return;
      if (refinements && refinements.parentNode !== sheetBody) sheetBody.prepend(refinements);
      if (searchBox && searchBox.parentNode !== sheetBody) sheetBody.prepend(searchBox);
    };
    const placeHome = () => {
      if (refinements && refinementsHome && refinements.parentNode !== refinementsHome) refinementsHome.insertBefore(refinements, refinementsNext);
      if (searchBox && searchHome && searchBox.parentNode !== searchHome) searchHome.insertBefore(searchBox, searchNext);
    };
    if (sheet) {
      (window.requestIdleCallback || ((fn) => setTimeout(fn, 200)))(placeInSheet);
      const onPhoneChange = () => { if (sheet.open) return; if (phone.matches) placeInSheet(); else placeHome(); };
      if (phone.addEventListener) phone.addEventListener('change', onPhoneChange); else if (phone.addListener) phone.addListener(onPhoneChange);
    }
    /* The sheet opens in the top layer as a popover (scrim from ::backdrop, above the header) instead of showModal():
       showModal() makes the rest of the page inert, and that restyles the whole page (0.8-2.3 s at CPU x4 here; the
       popover 56-112 ms). Modal behaviour is kept by hand: aria-modal, the scrim takes every tap outside, Escape
       closes, Tab stays inside, the page does not scroll, focus returns to the button. Without the Popover API (older
       browsers) it is showModal() as before. */
    const usePopover = Boolean(sheet && typeof sheet.showPopover === 'function' && typeof HTMLDialogElement !== 'undefined');
    if (usePopover) {
      sheet.setAttribute('popover', 'manual');
      sheet.setAttribute('aria-modal', 'true');
      sheet.addEventListener('keydown', (event) => {
        if (!sheet.open) return;
        if (event.key === 'Escape') { event.preventDefault(); sheet.close(); return; }
        if (event.key !== 'Tab') return;
        const items = [...sheet.querySelectorAll('button:not([disabled]), [href], input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea, [tabindex]:not([tabindex="-1"])')]
          .filter((node) => node.offsetParent !== null || node === document.activeElement);
        if (!items.length) return;
        const firstItem = items[0];
        const lastItem = items[items.length - 1];
        if (event.shiftKey && (document.activeElement === firstItem || !sheet.contains(document.activeElement) || document.activeElement === sheet.querySelector('h2'))) { event.preventDefault(); lastItem.focus(); }
        else if (!event.shiftKey && document.activeElement === lastItem) { event.preventDefault(); firstItem.focus(); }
      });
      /* a popover's backdrop lets taps through (UA pointer-events: none): a tap outside the sheet closes it and never
         reaches the page under the scrim */
      const outside = (event) => {
        if (!sheet.open || !sheet.matches(':popover-open')) return;
        const path = event.composedPath ? event.composedPath() : [];
        if (path.includes(sheet) || sheet.contains(event.target)) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.type === 'click' || event.type === 'touchend') sheet.close();
      };
      ['click', 'mousedown', 'touchend', 'auxclick'].forEach((type) => window.addEventListener(type, outside, { capture: true, passive: false }));
    }
    const openSheet = () => {
      if (!sheet || sheet.open) return;
      placeInSheet();
      if (usePopover) {
        try { sheet.showPopover(); sheet.setAttribute('open', ''); } catch (e) { if (typeof sheet.showModal === 'function' && !sheet.open) sheet.showModal(); }
      } else if (typeof sheet.showModal === 'function') sheet.showModal();
      else return;
      document.documentElement.classList.add('kc4-sheet-open');
      /* no aria-expanded on the button: it opens a modal dialog (aria-haspopup="dialog" says so), and changing it
         restyled the whole list through a legacy :has() rule in klik-catalogue.css (1.3-3.2 s at CPU x4) */
      const title = sheet.querySelector('h2');
      if (title) title.focus({ preventScroll: true });
    };
    if (toggle) toggle.addEventListener('click', openSheet);
    /* the chips need every design of the list: start on the first sign of intent (touch, hover, focus) */
    if (toggle && kfacetsBox) {
      const warm = () => { if (!allLoaded()) loadAll(); else if (!facetDefs) render(); };
      /* hover or keyboard focus warms early; a tap opens the sheet first and loads after its first paint, so the
         page parsing never delays the sheet */
      toggle.addEventListener('mouseenter', (event) => { if (!event.sourceCapabilities || !event.sourceCapabilities.firesTouchEvents) warm(); }, { once: true, passive: true });
      toggle.addEventListener('keyup', warm, { once: true, passive: true });
      toggle.addEventListener('click', () => requestAnimationFrame(() => setTimeout(warm, 0)));
    }
    if (sheet) {
      sheet.addEventListener('close', () => {
        if (usePopover) { try { if (sheet.matches(':popover-open')) sheet.hidePopover(); } catch (e) { /* already hidden */ } }
        document.documentElement.classList.remove('kc4-sheet-open');
        if (!phone.matches) placeHome();
        if (toggle) toggle.focus({ preventScroll: true });
      });
      sheet.addEventListener('click', (event) => {
        if (event.target !== sheet) return;
        const box = sheet.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) sheet.close();
      });
      sheet.querySelectorAll('[data-kc-sheet-close]').forEach((button) => button.addEventListener('click', () => sheet.close()));
    }
    const facetUrl = () => {
      const base = new URL(facets ? facets.getAttribute('action') || location.pathname : location.pathname, location.href);
      const current = new URL(location.href);
      current.searchParams.forEach((value, key) => { if (!/^filter\./.test(key) && key !== 'page' && key !== 'section_id') base.searchParams.append(key, value); });
      if (facets) new FormData(facets).forEach((value, key) => base.searchParams.append(key, String(value)));
      return base;
    };
    let facetTimer;
    if (facets) {
      facets.addEventListener('submit', (event) => { event.preventDefault(); location.assign(facetUrl()); });
      facets.addEventListener('change', () => {
        clearTimeout(facetTimer);
        const url = facetUrl();
        applyBtn.dataset.kcFacetUrl = url.href;
        applyBtn.setAttribute('aria-busy', 'true');
        setText(applyBtn, t('Show designs', 'عرض التصاميم'));
        facetTimer = setTimeout(async () => {
          try {
            const probe = new URL(url);
            probe.searchParams.set('section_id', sectionId);
            const response = await fetch(probe, { credentials: 'same-origin' });
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const data = JSON.parse((doc.querySelector('[data-kc-page]') || {}).textContent || '{}');
            if (applyBtn.dataset.kcFacetUrl === url.href) setText(applyBtn, t(`Show ${designs(Number(data.total) || 0)}`, `عرض ${designs(Number(data.total) || 0)}`));
          } catch (e) { /* the plain label stays */ }
          applyBtn.removeAttribute('aria-busy');
        }, 250);
      });
    }
    if (applyBtn) applyBtn.addEventListener('click', () => {
      if (applyBtn.dataset.kcFacetUrl) { location.assign(applyBtn.dataset.kcFacetUrl); return; }
      if (sheet && sheet.open) sheet.close();
    });

    /* ---------- category tabs and piece chips: the current one in view, the fade only where the row is cut ---------- */
    [tabs, $('.kc4-hub-chips'), $('.kc4-hub-row')].filter(Boolean).forEach((row) => {
      const fade = () => {
        const max = row.scrollWidth - row.clientWidth;
        const pos = Math.abs(row.scrollLeft);
        const state = max <= 2 ? 'none' : pos <= 2 ? 'end' : pos >= max - 2 ? 'start' : 'both';
        if (row.dataset.kcFade !== state) row.dataset.kcFade = state;
      };
      /* measured in the next frame, so the first script task never forces a layout */
      requestAnimationFrame(() => {
        const current = row.querySelector('[aria-current]');
        if (current) {
          const frame = row.getBoundingClientRect();
          const box = current.getBoundingClientRect();
          if (box.left < frame.left + 36 || box.right > frame.right - 36) {
            row.scrollLeft += box.left + box.width / 2 - (frame.left + frame.width / 2);
          }
        }
        fade();
        row.addEventListener('scroll', fade, { passive: true });
        window.addEventListener('resize', fade, { passive: true });
      });
    });

    /* ---------- Back keeps the place (K-028) ---------- */
    grid.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link || event.target.closest('[data-kc-save]')) return;
      const card = link.closest('[data-kc-product]');
      if (!card) return;
      const place = { list: location.pathname, limit, anchor: card.dataset.kcProduct, offset: Math.round(card.getBoundingClientRect().top), at: Date.now() };
      try { history.replaceState(Object.assign({}, history.state || {}, { kc: place }), ''); } catch (e) { /* state too large */ }
      try { sessionStorage.setItem(RESTORE_KEY, JSON.stringify(place)); } catch (e) { /* private mode */ }
    }, true);

    /* fill the shown step from the next server page(s), never more (K-117) */
    const topUp = async () => {
      if (!isDefault() || compute().length >= limit || Math.max(...loaded) >= pages) return;
      try {
        let next = Math.max(...loaded) + 1;
        while (compute().length < limit && next <= pages) { await fetchPage(next); next += 1; }
      } catch (e) { failed = true; }
      render();
    };
    const restore = async () => {
      const state = savedPlace;
      if (!state) {
        /* a shared or reloaded link with kpage: show that many designs at once */
        if (limit > PER) await topUp();
        /* a first page that left out twins or ready designs (search, all, custom-made) is topped up to a full step once
           the page has loaded; a full first page fetches nothing */
        else {
          if (document.readyState === 'complete') topUp();
          else window.addEventListener('load', () => topUp(), { once: true });
        }
        return false;
      }
      limit = Math.max(PER, Number(state.limit) || PER);
      try {
        if (isDefault()) {
          let next = Math.max(...loaded) + 1;
          while (compute().length < limit && next <= pages) { await fetchPage(next); next += 1; }
        } else {
          await loadAll();
        }
      } catch (e) { failed = true; }
      render();
      const card = state.anchor && grid.querySelector(`[data-kc-product="${CSS.escape(state.anchor)}"]`);
      if (card) {
        const y = card.getBoundingClientRect().top + window.scrollY - (Number(state.offset) || 0);
        window.scrollTo(0, Math.max(0, y));
      }
      return true;
    };

    /* ---------- the exact count of a free-text search (K-006): one design per twin pair, from the count view of
       sections/main-search.liquid (the section rendered by its file name: 250 handles per request, no page head) ---------- */
    const fetchExactCount = async () => {
      const base = new URL(location.pathname, location.href);
      const current = new URL(location.href);
      ['q', 'type', 'options[prefix]', 'preview_theme_id'].forEach((key) => { const v = current.searchParams.get(key); if (v != null) base.searchParams.set(key, v); });
      base.searchParams.set('section_id', 'main-search');
      const read = async (page) => {
        const url = new URL(base);
        url.searchParams.set('page', String(page));
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Search count ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const node = doc.querySelector('[data-kc-count-data]');
        if (!node) throw new Error('Search count missing');
        return JSON.parse(node.textContent || '{}');
      };
      try {
        const head = await read(1);
        const more = [];
        for (let p = 2; p <= Math.min(Number(head.pages) || 1, 8); p++) more.push(read(p));
        const items = (head.items || []).concat(...(await Promise.all(more)).map((data) => data.items || []));
        const handles = new Set(items.map((item) => item[0]));
        if (items.length) serverCount = items.filter((item) => !(item[1] && handles.has(item[1]))).length;
      } catch (e) { /* the page's own estimate stays */ }
      countExact = true;
      render();
    };

    /* ---------- wave 1 ux (UX-03): a list opened from search with colour=, seats= or width= says what that means ---------- */
    (() => {
      if (isSearch) {
        if (!root.dataset.kcSearchRoute) understoodCard(root, searchTerms);
        return;
      }
      const printNote = (text) => {
        if (!text || root.querySelector('.kc4-attr-note')) return;
        addUxStyles();
        const line = document.createElement('p');
        line.className = 'kc4-attr-note';
        line.setAttribute('role', 'note');
        lineText(line, text);
        (resultBar || grid).before(line);
      };
      /* UXR-04: a list the search relaxed ("sofa under 2000" → corner sofas that fit) prints the search's line, once, for
         this list only (klik-search-aliases.js stashNote; sessionStorage, two minutes) */
      try {
        const stash = JSON.parse(sessionStorage.getItem('klik:list-note:v1') || 'null');
        if (stash) {
          sessionStorage.removeItem('klik:list-note:v1');
          const keys = ['shape', 'seats', 'bed', 'width', 'price', 'colour', 'order'];
          const sig = (search) => { const sp = new URLSearchParams(search); return keys.map((k) => `${k}=${sp.get(k) || ''}`).join('&'); };
          if (Date.now() - (stash.at || 0) < 120000 && stash.path && location.pathname.replace(/\/$/, '').endsWith(String(stash.path).replace(/\/$/, '')) && sig(stash.search) === sig(location.search)) {
            printNote(String(stash.note || ''));
            return;
          }
        }
      } catch (e) { /* private mode */ }
      const colour = params.get('colour');
      const seatsParam = Number(params.get('seats')) || 0;
      const widthParam = params.get('width');
      if (!colour && !seatsParam && !widthParam) return;
      if (!window.KlikSearch || typeof KlikSearch.loadAttrs !== 'function') return;
      KlikSearch.loadAttrs().then(() => {
        const names = (window.KlikSearchAttrs && KlikSearchAttrs.colours) || {};
        const u = { key: root.dataset.kcHandle || '', colour: colour && names[colour] ? colour : '', seats: seatsParam, size: widthParam ? 1 : 0 };
        const text = KlikSearch.note(u);
        if (!text || root.querySelector('.kc4-attr-note')) return;
        addUxStyles();
        const line = document.createElement('p');
        line.className = 'kc4-attr-note';
        line.setAttribute('role', 'note');
        lineText(line, text);
        (resultBar || grid).before(line);
      }).catch(() => { /* no note */ });
    })();

    /* ---------- start ---------- */
    render();
    if (!isDefault() && !allLoaded()) loadAll();
    if (isSearch && !countExact) {
      if (document.readyState === 'complete') setTimeout(fetchExactCount, 0);
      else window.addEventListener('load', () => setTimeout(fetchExactCount, 0), { once: true });
    }
    restore();
    window.addEventListener('pageshow', (event) => { if (event.persisted) { saved = new Set(readSaved().map((item) => String(item.id))); render(); } });
    if (isSearch) publish('klik_search_submitted', { q: searchTerms, lang: AR ? 'ar' : 'en', results: serverCount, route: root.dataset.kcSearchRoute || null });
  });

  /* ---------- search page without a result grid: no results, help queries, empty search ---------- */
  document.querySelectorAll('[data-kc-search-page]').forEach((page) => {
    if (page.hasAttribute('data-catalogue') || page.dataset.searchReady) return;
    page.dataset.searchReady = 'true';
    const terms = page.dataset.kcSearchTerms || '';
    const route = page.dataset.kcSearchRoute || '';
    if (!terms) return;
    if (route) document.title = t(`Search: “${terms}” | ${siteName()}`, `البحث: «${terms}» | ${siteName()}`);
    else document.title = t(`No results for “${terms}” | ${siteName()}`, `لا توجد نتائج للبحث عن «${terms}» | ${siteName()}`);
    publish('klik_search_submitted', { q: terms, lang: AR ? 'ar' : 'en', results: route ? null : 0, route: route || null });

    if (!route) understoodCard(page, terms);
    const wa = page.querySelector('[data-kc-whatsapp]');
    if (wa && window.KlikWhatsApp && typeof KlikWhatsApp.build === 'function') {
      try { wa.href = KlikWhatsApp.build({ topic: 'search', summary: terms, url: location.href, lang: AR ? 'ar' : 'en' }) || wa.href; } catch (e) { /* keep the plain link */ }
    }

    const box = page.querySelector('[data-kc-alias]');
    const alias = window.KlikSearch && KlikSearch.alias ? KlikSearch.alias(terms) : terms;
    if (!box || route || !alias || fold(alias) === fold(terms)) return;
    const url = new URL(location.pathname, location.href);
    url.searchParams.set('q', alias);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    const probe = new URL(url);
    probe.searchParams.set('section_id', page.dataset.kcSection || '');
    fetch(probe, { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const cards = [...doc.querySelectorAll('[data-kc-grid] [data-kc-product]:not([data-kc-twin-hidden])')].slice(0, 8);
        if (!cards.length) return;
        const data = JSON.parse((doc.querySelector('[data-kc-page]') || {}).textContent || '{}');
        const total = Number(data.count) || cards.length;
        box.querySelector('[data-kc-alias-note]').textContent = t('Closest matches for your search:', 'أقرب النتائج لبحثك:');
        box.querySelector('[data-kc-alias-grid]').replaceChildren(...cards.map((card) => document.importNode(card, true)));
        const more = box.querySelector('[data-kc-alias-link]');
        if (total > cards.length) {
          more.href = url.pathname + url.search;
          more.textContent = t(`See all ${designs(total)}`, `عرض ${designs(total)}`);
        } else more.parentNode.hidden = true;
        box.hidden = false;
      })
      .catch(() => { /* the category tiles stay */ });
  });
})();
